import axios from 'axios'
export default {
  async updateUserSubscriptionEndDate (params) {
    return await axios.post('/api/spa/v1/super-admin/subscription/' + params.subscription_id, params)
  },
  async fetchPaymentDetail (params) {
    return await axios.post('/api/spa/v1/super-admin/payment-status/' + params.payment_id, params)
  },
  async getAdmins (params) {
    return await axios.get('/api/spa/v1/super-admin/admins', { params })
  },
  async addAdmin (params) {
    return await axios.post('/api/spa/v1/super-admin/add-admin', params)
  },
  async removeAdmin (id) {
    return await axios.delete('/api/spa/v1/super-admin/remove-admin/' + id)
  },
  async updateAdmin (params) {
    return await axios.post('/api/spa/v1/super-admin/update-admin/' + params.id, params)
  },
  async updatePassword (params) {
    return await axios.post('/api/spa/v1/super-admin/update-password', params)
  },
  async updateUsername (params) {
    return await axios.post('/api/spa/v1/super-admin/update-username', params)
  }
}
